import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: React.ReactNode;
  error?: string;
}

export function Input({ label, icon, error, className = '', id, ...rest }: InputProps) {
  const fieldId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="flex flex-col gap-1.5 mb-4">
      {label && (
        <label
          htmlFor={fieldId}
          className="tb-label"
        >
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        {icon && (
          <span className="absolute left-4 text-[18px] flex items-center pointer-events-none text-text-muted">
            {icon}
          </span>
        )}
        <input
          id={fieldId}
          className={[
            'w-full h-[50px] bg-bg-input border-2 border-border-neutral rounded-input',
            'px-4 text-[16px] font-semibold text-text-primary font-nunito',
            'placeholder:text-text-muted',
            'focus:border-brand-blue focus:outline-none transition-colors duration-150',
            'disabled:bg-bg-inputSoft disabled:text-text-muted disabled:cursor-not-allowed',
            error ? 'border-semantic-danger focus:border-semantic-danger' : '',
            icon ? 'pl-11' : '',
            className,
          ].join(' ')}
          {...rest}
        />
      </div>
      {error && (
        <p className="tb-caption text-semantic-danger">{error}</p>
      )}
    </div>
  );
}
